export const currencyWithPrefix = (value: number) => {
    const formattedValue = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);

    return formattedValue;
};

export const concurrencyWithoutPrefix = (value: number) => {
    const formattedValue = currencyWithPrefix(value);
    return formattedValue.replace(/^R\$\s?/, '');
}

export const currencyToNumber = (value: string) => {
    if (!value) return 0;

    const numericString = value.replace(/[^\d,-]/g, '').replace('.', '').replace(/,/g, '.');
    const numberValue = parseFloat(numericString);

    return isNaN(numberValue) ? 0 : numberValue;
}

// Variante para valores em formato americano (vírgula = milhar, ponto = decimal
// - ex: "66,646.75", "994.727640190"), usada quando a corretora exporta a
// planilha nesse formato (ex: XP) em vez do formato brasileiro assumido por
// currencyToNumber acima. Aplicar a função errada silenciosamente infla o
// valor em ~100x pra qualquer número com casas decimais (ex: "12.70" vira
// 1270 via currencyToNumber) - não são intercambiáveis.
export const currencyToNumberUs = (value: string) => {
    if (!value) return 0;

    const numericString = value.replace(/[^\d.-]/g, '');
    const numberValue = parseFloat(numericString);

    return isNaN(numberValue) ? 0 : numberValue;
}